// src/services/subscriptionPlansService.js
import { supabase } from '../config';

class SubscriptionPlansService {
  /**
   * Get all subscription plans
   * @param {boolean} frontendOnly - If true, only returns plans with show_on_frontend = true
   */
  async getPlans(frontendOnly = true) {
    try {
      // Query Supabase directly - simple and reliable
      let query = supabase
        .from('subscription_plans')
        .select('*')
        .eq('is_active', true);

      // Filter by show_on_frontend if requested
      if (frontendOnly) {
        query = query.eq('show_on_frontend', true);
      }

      // Order by sort_order
      query = query.order('sort_order', { ascending: true });

      const { data, error } = await query;

      if (error) {
        console.error('Error fetching subscription plans from Supabase:', error);
        throw error;
      }

      return {
        success: true,
        plans: data || []
      };
    } catch (error) {
      console.error('Error fetching subscription plans:', error);
      // Return empty plans array on error instead of throwing
      return { success: false, plans: [], error: error.message };
    }
  }

  /**
   * Create a new subscription plan
   */
  async createPlan(planData) {
    try {
      const response = await fetch('/api/subscription_plans_api', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(planData),
      });

      if (!response.ok) {
        throw new Error('Failed to create subscription plan');
      }

      return await response.json();
    } catch (error) {
      console.error('Error creating subscription plan:', error);
      throw error;
    }
  }

  /**
   * Update a subscription plan
   */
  async updatePlan(planData) {
    try {
      const response = await fetch('/api/subscription_plans_api', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(planData),
      });

      if (!response.ok) {
        throw new Error('Failed to update subscription plan');
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating subscription plan:', error);
      throw error;
    }
  }

  /**
   * Delete a subscription plan
   */
  async deletePlan(planId) {
    try {
      const response = await fetch(`/api/subscription_plans_api/${planId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to delete subscription plan');
      }

      return await response.json();
    } catch (error) {
      console.error('Error deleting subscription plan:', error);
      throw error;
    }
  }
}

// Create and export singleton instance
const subscriptionPlansService = new SubscriptionPlansService();
export default subscriptionPlansService;










